'use strict';

const angular = require('angular');

module.exports = angular
  .module('spinnaker.kubernetes.search.formatter', [])
  .factory('kubernetesSearchResultFormatter', function($q) {
    return {
      instances: function(entry) {
        return $q.when((entry.name || entry.instanceId) + ' (' + entry.namespace + ')');
      },
      serverGroups: function(entry) {
        return $q.when((entry.name || entry.serverGroup) + ' (' + (entry.namespace || entry.region) + ')');
      },
      loadBalancers: function(entry) {
        return $q.when(entry.name + ' (' + (entry.namespace || entry.region) + ')');
      },
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/kubernetes/src/search/resultFormatter.js